export default __webpack_public_path__ + "static/media/t5.3223b0d4.jpg";